import React from "react";
import SidebarSubmenu from "../Sidebar/SidebarSubmenu";
import NavSubItem from "../Sidebar/NavSubItem";
import IconSettingsImager from "../../Icons/TopCommandPanel/SettingsImager";
import IconPsrCamera from "../../Icons/TopCommandPanel/PsrCamera";
import IconSettingsStorage from "../../Icons/TopCommandPanel/SettingsStorage";
import IconPreference from "../../Icons/Servicing/Tools/Preference";
import IconBackup from "../../Icons/TopCommandPanel/SystemBackup";
import IconVectorEditor from "../../Icons/TopCommandPanel/VectorEditor";
import { getModuleStateById } from "../../redux/reducers/ModuleStateReducer";
import { useTypedSelector } from "../../redux/reducers/RootReducer";
import { ESuiteMode } from "../../Model/ModuleState";
import { getModuleCapability } from "../../redux/reducers/ModuleCapabilitiesReducer";
import { getModules } from "../../redux/reducers/ModuleReducer";
import { EModuleType } from "../../Model/EModuleType";
import {
  EBarcodeScannerType,
  ECarrierAutoCalibrationType,
} from "../../Model/PsrCapabilites";

export default function SettingsNavSubMenu() {
  const isTesting = useTypedSelector(
    (state) =>
      getModuleStateById(state)["Suite"].suite?.suiteMode == ESuiteMode.Testing
  );

  const isAutoCalibrating = useTypedSelector(
    (state) =>
      getModuleStateById(state)["Suite"].suite?.suiteMode ==
      ESuiteMode.AutoCalibrating
  );

  const psrModules = useTypedSelector((state) =>
    getModules(state, EModuleType.PSR)
  );
  const psrModule = psrModules[0];
  const psrIdentifier = psrModule.identifier;
  const psrCapability = useTypedSelector((state) =>
    getModuleCapability(state, psrIdentifier)
  ).psr;

  const isSupportPsrCamera =
    psrCapability !== undefined
      ? psrCapability.barcodeScanner.barcodeScannerType ===
          EBarcodeScannerType.PsrCamera ||
        psrCapability?.carrierAutoCalibration?.carrierAutoCalibrationType ===
          ECarrierAutoCalibrationType.PsrCamera
      : false;

  const doHidden: React.CSSProperties = {
    display: "none",
  };
  const doDisplay: React.CSSProperties = {};
  return (
    <SidebarSubmenu>
      <NavSubItem
        label="Vector Editor"
        key="vectorEditor"
        to="/settings/vector-editor"
        icon={<IconVectorEditor />}
        disabled={isTesting || isAutoCalibrating}
      />

      <NavSubItem
        label="Storage"
        key="storage"
        to="/settings/storage"
        icon={<IconSettingsStorage />}
        disabled={isTesting || isAutoCalibrating}
      />

      <NavSubItem
        label="Imager"
        key="imager"
        to="/settings/imager"
        icon={<IconSettingsImager />}
        disabled={isTesting || isAutoCalibrating}
      />

      <NavSubItem
        label="Psr Camera"
        key="psr-camera"
        to="/settings/psr-camera"
        icon={<IconPsrCamera />}
        disabled={isTesting || isAutoCalibrating}
        style={isSupportPsrCamera ? doDisplay : doHidden}
      />

      <NavSubItem
        label="System Backup"
        key="systembackup"
        to="/settings/system-backup"
        icon={<IconBackup />}
        disabled={isTesting || isAutoCalibrating}
      />

      <NavSubItem
        label="Preferences"
        key="preferences"
        to="/settings/preferences"
        icon={<IconPreference />}
        disabled={isTesting || isAutoCalibrating}
      />
    </SidebarSubmenu>
  );
}
